import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";

export const GetContactAvatarLink = (id: string | null) : string => {
    return !id ?
            '' :
            GET_FILE_BY_ID_API_ROUTE + id + "&rand=" + Math.random();
}